import { normalizeCardNumber } from '@src/domains/payments/core/normalizeCardNumber';
import { normalizeInstallments } from '@src/domains/payments/core/normalizeInstallments';
import { parseCardValidityParts } from '@src/domains/payments/core/parseCardValidityParts';

// Optional across the board so both flows' inputs satisfy it as they are: the DOM yields whatever
// fields the form rendered, the direct link form yields all of them.
export type CardPaymentCoreInput = {
  validity?: string;
  cardNumber?: string;
  securityCode?: string;
  holder?: string;
  installments?: string | number;
};

export type CardPaymentCore = {
  validityMonth: string;
  validityYear: string;
  cardNumber: string;
  securityCode: string;
  holder: string;
  installments: number;
};

// Every card payload field whose rule is the same in both flows. What is left out is left out because
// it genuinely differs: holderIdentity (the legacy checkout hides the field from foreign buyers, the
// direct link nulls it) and billingAddress (nulled versus omitted, countryCode sent versus not).
export const buildCardPaymentCore = (input: CardPaymentCoreInput): CardPaymentCore => {
  const { validityMonth, validityYear } = parseCardValidityParts(input.validity);

  return {
    validityMonth,
    validityYear,
    cardNumber: normalizeCardNumber(input.cardNumber as string),
    securityCode: input.securityCode as string,
    holder: input.holder as string,
    installments: normalizeInstallments(input.installments as string),
  };
};
